import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputReadOnlyUI from '../../../widgets/form/InputReadOnlyUI'

const SPUpdateModalUI = ({context, successMsg, errorList, setErrorList,
    // modes
    updateMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
    //
    parameterName, financialYear,
    parameterValue, onParameterValueChange, parameterValueError, setParameterValueError
  }) =>
  <ModalFormUI
    context={context}
    titleLabel='Update parameter'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputReadOnlyUI name='parameterName' label='Parameter name'
      required={true} value={parameterName}
    />
    <InputReadOnlyUI name='financialYear' label='Financial year'
      required={true} value={financialYear}
    />
    <InputTextSF type='text'  name='parameterValue' label='Parameter value'
      required={true} maxLength={100} autoFocus={true}
      value={parameterValue} onChange={onParameterValueChange}
      error={parameterValueError} setError={setParameterValueError}
      help={parameterName === 'climeLoanType' ? "Enter 'project' (for amortized) or 'interest_only' or 'int_then_prj' (for hybrid), or 'inv_discount' or 'lease'" : ''}
    />
  </ModalFormUI>

export default SPUpdateModalUI
